<template>
  <div class="bank-detail">
    <div class="bank-detail-main">
      <div class="flex flex-column-center flex-row-between">
        <div class="bank-detail-text1">银行账户详细信息</div>

        <div class="flex flex-column-center flex-row-between bank-detail-text2">
          <img src="../../assets/img/client/booking/copy.png" width="16" height="16" alt="copy">
          <div>复制银行详细信息</div>
        </div>
      </div>
      <div class="flex flex-column-center margin-top_16">
        <div class="bank-detail-logo">
          <img :src="data.logo" style="width: 40px;">
        </div>
        <div class="flex-1 margin-left_4">
          <div class="bank-detail-text3">
            {{ data.bankNameEn }}
          </div>
          <div class="bank-detail-text4 margin-top_4">
            {{ data.abbreviationEn }}
          </div>
        </div>
      </div>
      <div class="flex margin-top_24">
        <div class="flex-1">
          <div class="bank-detail-text5">收款公司名称</div>
          <div class="bank-detail-text6">{{ data.companyNameEn }}</div>
        </div>
        <div class="flex-1 margin-left_24">
          <div class="bank-detail-text5">收款公司地址</div>
          <div class="bank-detail-text6">{{ data.companyAddressEn }}</div>
        </div>
      </div>
      <div class="flex margin-top_16">
        <div class="flex-1">
          <div class="bank-detail-text5">账号</div>
          <div class="bank-detail-text6">{{ data.accountNo }}</div>
        </div>
        <div class="flex-1 margin-left_24">
          <div class="bank-detail-text5">银行名称</div>
          <div class="bank-detail-text6">{{ data.nameEn }}</div>
        </div>
      </div>
      <div class="flex margin-top_16">
        <div class="flex-1">
          <div class="bank-detail-text5">银行地址</div>
          <div class="bank-detail-text6">{{ data.bankAddressEn }}</div>
        </div>
      </div>
      <div class="flex margin-top_16">
        <div class="flex-1">
          <div class="bank-detail-text5">ABA routing</div>
          <div class="bank-detail-text6">{{ data.ABARouting }}</div>
        </div>
        <div class="flex-1 margin-left_24">
          <div class="bank-detail-text5">Swift code</div>
          <div class="bank-detail-text6">{{ data.swift }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetDefaultBank
} from '@/api/base.js'
export default {
  components: {},
  data() {
    return {
      data: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getBankInfo()
  },
  mounted() {},
  methods: {
    getBankInfo() {
      GetDefaultBank().then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (this.data.logo) {
            var json = JSON.parse(this.data.logo)
            if (json.length > 0) {
              this.data.logo = define.comUrl + json[0].url
            } else {
              this.data.logo = undefined
            }
          } else {
            this.data.logo = undefined
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.bank-detail {
		width: 100%;
		padding: 16px;
		background: #ffffff;
		border-radius: 8px;
		box-sizing: border-box;

		.bank-detail-main {
			padding: 16px;
			background: #f5f7fa;
			border-radius: 8px;
			box-sizing: border-box;

			.bank-detail-text1 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #777777;
				line-height: 18px;
				text-align: left;
				font-style: normal;
			}

			.bank-detail-text2 {
				cursor: pointer;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #3370ff;
				line-height: 18px;
				text-align: center;
				font-style: normal;
			}

			.bank-detail-text3 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
				line-height: 22px;
				text-align: left;
				font-style: normal;
			}

			.bank-detail-text4 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #777777;
				line-height: 18px;
				text-align: left;
				font-style: normal;
			}

			.bank-detail-text5 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #777777;
				line-height: 24px;
				text-align: left;
				font-style: normal;
			}

			.bank-detail-text6 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 550;
				font-size: 13px;
				color: #333333;
				line-height: 24px;
				text-align: left;
				font-style: normal;
			}

			.bank-detail-logo {
				width: 40px;
				height: 40px;
				border: 1px solid #d9d9d9;
				border-radius: 50%;
			}
		}
	}
</style>
